import { mdiStar, mdiStarOutline } from '@mdi/js';
import Icon from '@mdi/react';
import { CHECK_TYPES_NEEDED_PLANS, PLAN, getCheckTypeFromSlug } from '@solid/shared';
import { Button } from '@solid/shared/ui';
import React, { useContext } from 'react';
import { Link } from 'react-router-dom';
import { PaymentPopupContext } from '../../contexts/payment-popup.context';
import { AuthContext } from '../../contexts/auth.context';
import { KirbyCheckGroupEntry } from '@solid/shared/kirby';
import { canUseFavorites } from '../../services/setting.service';
import * as Styled from './CheckCard.styles';
import { useTranslation } from 'react-i18next';

interface CheckCardProps {
  check: KirbyCheckGroupEntry;
  isFavorite: boolean;
  onFavoriteStateChange: () => void;
  hasShadow?: boolean;
}

const CheckCard: React.FC<CheckCardProps> = ({ check, isFavorite, onFavoriteStateChange, hasShadow }) => {
  const { auth } = useContext(AuthContext);
  const checkPlan = check.plan.split(',').map(plan => plan.trim() as PLAN);
  // const checkType = getCheckTypeFromSlug(check.slug as string);
  // const plan = check.plan.toLowerCase() === PLAN.FREE.toLowerCase() ? PLAN.FREE : check.plan.toLowerCase() === PLAN.PLUS.toLowerCase() ? PLAN.PLUS : PLAN.PLUS_TRIAL;
  // const canStartCheck = plan === PLAN.FREE ? true: [PLAN.PLUS, PLAN.PLUS_TRIAL].includes(auth.user.plan);

  // let plan: PLAN;
  // if (checkPlan.includes(PLAN.FREE)) {
  //   plan = PLAN.FREE;
  // } else if (checkPlan.includes(PLAN.PLUS_TRIAL)) {
  //   plan = PLAN.PLUS_TRIAL;
  // } else if (checkPlan.includes(PLAN.PLUS)) {
  //   plan = PLAN.PLUS;
  // }

  // const canStartCheck = checkPlan.includes(PLAN.FREE) || checkPlan.includes(auth.user.plan);

  const resolveCheckPlan = (checkPlans: PLAN[], userPlan: PLAN): { canStart: boolean; displayPlan?: PLAN } => {
    const canStart = checkPlans.includes(PLAN.FREE) || checkPlans.includes(userPlan);

    let displayPlan: PLAN | undefined;

    if (checkPlans.includes(userPlan)) {
      displayPlan = userPlan;
    } else if (userPlan === PLAN.FREE && checkPlans.includes(PLAN.PLUS)) {
      displayPlan = PLAN.PLUS;
    } else {
      displayPlan = [...Object.values(PLAN)].reverse().find(plan => checkPlans.includes(plan));
    }

    return { canStart, displayPlan };
  };

  const { canStart: canStartCheck, displayPlan: plan } = resolveCheckPlan(checkPlan, auth.user.plan);

  // const canStartCheck = CHECK_TYPES_NEEDED_PLANS[checkType].includes(auth.user.plan);

  const paymentPopup = useContext(PaymentPopupContext);
  const { t } = useTranslation();
  return (
    <Styled.Checkup key={check.slug} $isLocked={!canStartCheck} $hasShadow={hasShadow}>
      {canStartCheck && canUseFavorites(auth.user.plan) && (
        <Styled.FavoriteButton
          hasIconOnly
          variant='transparent'
          onClick={() => onFavoriteStateChange()}
          title={isFavorite ? t('checks.common.removeFavorite') : t('checks.common.addFavorite')}>
          <Icon size='1.25rem' path={isFavorite ? mdiStar : mdiStarOutline} />
        </Styled.FavoriteButton>
      )}

      {check.flag && (
        <Styled.FlagWrapper>
          <img src={check.flag} alt='' />
        </Styled.FlagWrapper>
      )}

      <Styled.PlanTag plan={plan} />

      <Styled.Question dangerouslySetInnerHTML={{ __html: check.question }}></Styled.Question>

      {canStartCheck ? (
        <Link to={`/checks/new/${check.slug}`}>
          <Styled.StartButton>{t('checks.common.startCheck')}</Styled.StartButton>
        </Link>
      ) : (
        <Button onClick={() => paymentPopup.setOpen(true)}>{t('checks.common.unlock')}</Button>
      )}

      {check.active === false && (
        <Styled.UnlistedOverlay>
          <p>{t('checks.common.checkIsBuilding')}</p>
        </Styled.UnlistedOverlay>
      )}
    </Styled.Checkup>
  );
};

export default CheckCard;
